module.exports = __webpack_public_path__ + "img/img151_10.b334c30d.png";